import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../../components/ui/alert-dialog";

export const Confirm = ({ children, title, text, onConfirm }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
    <AlertDialogContent className="bg-[var(--ink-2)] border-white/10 rounded-none">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display text-2xl font-medium">{title}</AlertDialogTitle>
        <AlertDialogDescription className="text-slate-300">{text}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="rounded-none" data-testid="confirm-cancel-button">Cancel</AlertDialogCancel>
        <AlertDialogAction className="rounded-none bg-rose-600 hover:bg-rose-500 text-white" onClick={onConfirm} data-testid="confirm-delete-button">Delete</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
